import React from 'react';

import { Icons } from 'widget/components';
import * as Env from 'widget/env';

interface Closer {
  setIsActive: Env.SetState<boolean> | undefined;
}

const Closer = ({ setIsActive }: Closer) => (
  <button
    className="whatcrm-widget-modal__closer"
    onClick={() => (setIsActive ? setIsActive(false) : undefined)}
    type="button"
  >
    <Icons.CloseCross fill="contrast" size={24} />
  </button>
);

export default Closer;
